
import PercentBox from '@/components/shared/PercentBox';
import AreaChart from "@/components/chart/AreaChart";
import { companyLogoHandler } from '@/mixins';
import FormatterService from "@/service/FormatterService";
import theme from '@/assets/theme.scss';

export default {
    name: 'FinAgentChartList',

    components: {
        PercentBox,
        AreaChart,
    },

    mixins: [ companyLogoHandler ],

    props: {
        configurations: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            isLoading: false,
            stockChartsData: []
        }
    },

    computed: {
        colors() {
            return [
                theme['chart-graph-color-1'],
                theme['chart-graph-color-2'],
                theme['chart-graph-color-3'],
                theme['chart-graph-color-4'],
                theme['chart-graph-color-5'],
                theme['chart-graph-color-6'],
                theme['chart-graph-color-7'],
                theme['chart-graph-color-8'],
                theme['chart-graph-color-9'],
                theme['chart-graph-color-10'],
                theme['chart-graph-color-11'],
                theme['chart-graph-color-12'],
                theme['chart-graph-color-13'],
                theme['chart-graph-color-14'],
                theme['chart-graph-color-15'],
                theme['chart-graph-color-16'],
            ]
        },
    },

    watch: {
        configurations: {
            immediate: true,
            handler(newConfigurations) {
                this.cancelActiveRequests()
                if (newConfigurations && newConfigurations.length > 0) {
                    this.stockChartsData = this.getInitialStockChartsData(newConfigurations)
                    this.fetchData(this.stockChartsData)
                }
            }
        }
    },

    created() {
        this.format = new FormatterService()
    },

    methods: {
        cancelActiveRequests() {
            if (this.activeQuotesRequest) {
                this.activeQuotesRequest.cancel()
            }
        },

        getStockDetailsPageLink(slug) {
            if (!slug) {
                return ''
            }
            return { name: this.$getTranslatedRouteName('aktie-share'), params: { share: slug } }
        },

        getInitialStockChartsData(configurations) {
            return configurations.map((s, index) => {
                const comparisons = s.comparisons.length <= 1 ? [] :
                    s.comparisons.slice(1).map((s, i) => ({...s, color: this.colors[i]}));
                const chartType = comparisons.length > 0 ? 'performance' : 'value';

                return {
                    id: `${s.slug}-${s.title}-${index}`,
                    ...s,
                    ...s.comparisons?.[0], // the first item of comparisons is the main stock of chart
                    comparisons,
                    chartType
                };
            });
        },

        updateChartDataWithQuotes(quotesMapping = {}) {
            let tempStockChartsData = [...this.stockChartsData];
            tempStockChartsData = tempStockChartsData.map(s => {                
                if (quotesMapping[s.isin]) {
                    return { ...s, ...quotesMapping[s.isin]};
                }
                return s;
            })

            this.stockChartsData = tempStockChartsData;
        },

        async fetchQuotesData(isins = []) {
            try {
                this.cancelActiveRequests();
                const url = '/api/quotes/current';
                const params = { isins };
                const axiosSource = this.$axios.CancelToken.source();
                const cancelToken = axiosSource.token;
                this.activeQuotesRequest = { cancel: axiosSource.cancel, msg: "Cancel loading quotes..." };
                const res = await this.$axios.get(url, { params, cancelToken });
                const quotesData = res.data;

                this.activeQuotesRequest = null;
                return quotesData;
            } catch (error) {
                if (this.$axios.isCancel(error)) {
                    throw error
                }
                this.activeQuotesRequest = null;
                return null;
            }
         },

        async fetchData(stockChartsData) {
            try {
                this.isLoading = true;
                const isins = stockChartsData.map(c => c.isin).filter(i => !!i);
                const res = await this.fetchQuotesData(isins);
                this.updateChartDataWithQuotes(res);
                this.isLoading = false;
            } catch (error) {
                if (this.$axios.isCancel(error)) {       
                    return
                }
                this.isLoading = false
            }
        }
    }
}
